import { render, staticRenderFns } from "./SpecialPricingChipsCell.vue?vue&type=template&id=66adc664&scoped=true"
import script from "./SpecialPricingChipsCell.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialPricingChipsCell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SpecialPricingChipsCell.vue?vue&type=style&index=0&id=66adc664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66adc664",
  null
  
)

export default component.exports